module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og lulesamisk_primærlogo_neg(hvit).df1b38e6.pdf";